<template>
  <a-space>
    <a-popover trigger="hover" placement="bottom">
      <template #content>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6em">
          <a-tag color="red" style="font-size: 15px">微信扫一扫联系客服</a-tag>
        </div>
        <div>
          <img src="~@/assets/kefu.jpg" width="300" height="300" />
        </div>
      </template>
      <a-button type="primary"> 联系客服 </a-button>
    </a-popover>
    <a-button type="primary" @click="openPage">使用教程</a-button>
  </a-space>
</template>
<script>
export default {
  data() {
    return {
      //  kefuImageUrl: "https://static.zzbtool.com/static/dyorder/1688_duan/zfb.jpg",
      //  kefuImageUrl: "/images/kefu.jpg",

      //  courseUrl: 'https://www.yuque.com/qiangzi-0veiu/ge9g4z/dfpcbn2irt604115?singleDoc#'
      courseUrl: "https://www.yuque.com/qiangzi-0veiu/ge9g4z/cu1bt6etzw37apmz?singleDoc",
    };
  },
  methods: {
    openPage() {
      window.open(this.courseUrl);
    },
  },
};
</script>
